import "./globals.css";
import { AuthProvider } from "./context/AuthContext"; // ✅ make sure this path is correct
import ToastProvider from "./components/ToastProvider";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <AuthProvider>
      {children}
      <ToastProvider />
    </AuthProvider>
  );
}
